import React from 'react';
import { Button, styled, Typography } from '@mui/material';
import Dialog from 'components/dialogs/Dialog';
import { moneyFormat } from 'helpers/moneyFormat';

const Container = styled('div')({ display: 'flex', flexDirection: 'column', gap: 16 });

const Totals = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
}));

const Total = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.25, 1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.grey[50],
}));

const Actions = styled('div')({ display: 'flex', justifyContent: 'flex-end', gap: 10 });

interface CloseSurgerieDialogProps {
  budget: { id_int: number; value_total: number; value_paid: number };
  onConfirm(): void;
  onExited(): void;
}

const CloseSurgerieDialog: React.FC<CloseSurgerieDialogProps> = ({ budget, onConfirm, onExited }) => {
  const paid = Number(budget.value_paid) || 0;
  const balance = Math.max(Math.round((Number(budget.value_total) - paid) * 100) / 100, 0);

  return (
    <Dialog title={`Fechar orçamento #${budget.id_int}`} maxWidth="sm" onExited={onExited}>
      <Container>
        <Typography variant="body2">
          O orçamento passa para a lista de fechados. Os valores não poderão mais ser alterados.
        </Typography>

        <Totals>
          <Total>
            <Typography variant="caption" color="textSecondary">
              Total
            </Typography>
            <Typography variant="subtitle1" fontWeight={700}>
              {moneyFormat(budget.value_total)}
            </Typography>
          </Total>
          <Total>
            <Typography variant="caption" color="textSecondary">
              Pago
            </Typography>
            <Typography variant="subtitle1" fontWeight={700} color="success.main">
              {moneyFormat(paid)}
            </Typography>
          </Total>
          <Total>
            <Typography variant="caption" color="textSecondary">
              Saldo
            </Typography>
            <Typography variant="subtitle1" fontWeight={700} color={balance > 0 ? 'error' : 'textPrimary'}>
              {moneyFormat(balance)}
            </Typography>
          </Total>
        </Totals>

        {balance > 0 && (
          <Typography variant="caption" color="textSecondary">
            O saldo pode ser pago depois do fechamento, na aba Pagamentos do orçamento.
          </Typography>
        )}

        <Actions>
          <Button variant="outlined" color="inherit" onClick={onExited}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            Fechar orçamento
          </Button>
        </Actions>
      </Container>
    </Dialog>
  );
};

export default CloseSurgerieDialog;
